import styles from './style.module.css';
import icDropoff from '../../../../assets/ic-dropoff.svg';
import icSchedule from '../../../../assets/ic-schedule-x.svg';
import momentJalaali from "moment-jalaali";
import { checkTimestamp, get_lang } from "../../../../helper/UserData/userdate";
import { useTranslation } from 'react-i18next';
import Typography from '../../../../design-system/lib/Typography';
import { Dropofff } from '../../../../assets';
const _ = require('lodash');

export const DeliveryRow = ({ dropoff, data }) => {
    const { t, i18n } = useTranslation();

    if (_.isEmpty(dropoff)) {
        return null
    }
    return <div className={styles.DeliveryRowContainer}>
          <img src={Dropofff}  className={styles.DeliveryRowImageIcon} style={{marginInlineEnd : (data.type == "Ondemand" && data.dropoffs.length > 1) ? "2px" :"8px"}}/>

        {(data.type == "Ondemand" && data.dropoffs.length > 1) && <Typography weight='Body_Small_Regular' text={`+${data.dropoffs.length - 1}`}  style={{paddingInlineEnd:"8px",borderInlineEnd :"1px solid #80808033", marginInlineEnd:"8px" }} />}

        {/* {(data.type == "Ondemand" && data.dropoffs.length > 1) ? (<span className={styles.moreFlag}>  {`+${data.dropoffs.length - 1}`} <span className={styles.DeliveryRowImageIconBorder} style={{ margin: "0" }}>  <span className={styles.DeliveryRowImageIcon} > </span> </span> </span>) : (<span className={styles.DeliveryRowImageIconBorder}> </span>)} */}
        <Typography weight='Body_Small_Regular' text={dropoff.locationType == "address" ? dropoff.address : dropoff.servicePoint?.name} className={styles.DeliveryRowAddress} />

        {(dropoff.scheduleDateAfter != 0 || dropoff.scheduleDateBefore != 0) &&
            <span className={styles.DeliveryRowSchedule}>
                <Typography weight='Body_Small_Regular' text={momentJalaali(dropoff.scheduleDateAfter || dropoff.scheduleDateBefore).locale(get_lang()).format(checkTimestamp(dropoff.scheduleDateAfter || dropoff.scheduleDateBefore))} className={styles.DeliveryRowScheduleText} />

            </span>


        }

        {["Delivery", "PickupDelivery"].indexOf(data.type) > -1 &&
            <>
                {data.isPickupDelivery && <span className={styles.OrderTypePD}> {t("tab_PickupDelivery")}</span>}
                {data.type == "Delivery" && <span className={data.isPickupDelivery ? styles.OrderTypewithPD : styles.OrderType}> {t("DropOffFlag")} </span>}
            </>
        }


        {/* <span className={styles.OrderType}> D </span> */}

    </div>
};




